export default __webpack_public_path__ + "static/media/slider-arrow-left.3f5c03be.svg";